import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { List, ListItemText } from "@material-ui/core";
import ListHeader from "./Header";
import Order from "./Order";
import useStyles from "./styles";

const OrdersList = ({ device_id, orders, onRefresh, onDone }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ListHeader onRefresh={onRefresh} />
      <List subheader={<li />}>
        {isEmpty(orders) ? (
          <ListItemText className={classes.centerContent} secondary={"Orders not found"} />
        ) : (
          orders.map((order) => (
            <Order key={`section-${order.id}`} order={order} onDone={onDone} device_id={device_id} />
          ))
        )}
      </List>
    </div>
  );
};

OrdersList.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object).isRequired,
  onRefresh: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};

export default OrdersList;
